import * as React from "react";
import { useQuery, useMutation } from "@grandvisionhq/graphql";
import { toPersonalDetails } from "../../../mappers/Profile/mappers/profile.js";
import UPDATE_PERSONAL_DETAILS from "../../../operations/mutations/Profile/operations/mutations/update-personal-details.js";
import GET_PERSONAL_DETAILS from "../../../operations/queries/Profile/operations/queries/get-personal-details.js";
const usePersonalDetails = ({ onError, onCompleted } = {}) => {
  const setOptions = React.useCallback(
    (reason) => ({
      onError: (error) => {
        onError?.({ reason, error });
      },
      onCompleted: (data) => {
        onCompleted?.({ reason, data });
      },
      // Currently the BE response does not resolve fast enough so we have to temporarily
      // increase the timeout that is configured globally in graphql/src/apollo/client.ts.
      // When the backend performance has been improved, we will remove this and revert
      // to the global config of 10s.
      context: {
        timeout: 2e4
      }
    }),
    [onCompleted, onError]
  );
  const queryOptions = React.useMemo(() => setOptions("QUERY"), [setOptions]);
  const query = useQuery(GET_PERSONAL_DETAILS, queryOptions);
  const mutationOptions = React.useMemo(() => setOptions("MUTATION"), [setOptions]);
  const [mutationCallback, mutation] = useMutation(UPDATE_PERSONAL_DETAILS, {
    ...mutationOptions,
    refetchQueries: [{ query: GET_PERSONAL_DETAILS }]
  });
  return React.useMemo(
    () => ({
      personalDetailsData: toPersonalDetails(query.data?.me?.personalDetails),
      updatePersonalDetails: async (personalDetails, userId) => {
        await mutationCallback({
          variables: {
            customerId: userId,
            input: personalDetails
          }
        });
      },
      isFetching: query.loading,
      fetchError: query.error,
      isUpdating: mutation.loading
    }),
    [
      mutation.loading,
      mutationCallback,
      query.data?.me?.personalDetails,
      query.error,
      query.loading
    ]
  );
};
export {
  usePersonalDetails
};
//# sourceMappingURL=use-personal-details.js.map
